import swalAlert from '../../utils/helpers/swalAlert'
import API from './commonAPI'

// TODO: translate succesWithTimer
const POST = async (endpoint, body, showAlert = true) => {
  try {
    const response = await API.post(endpoint, body)
    if (showAlert) {
      await swalAlert.succesWithTimer('El registro se ha creado correctamente')
    }
    return response.data
  } catch (error) {
    swalAlert.error(error?.response?.data?.message || error?.message)
    return null
  }
}

const POST_FILE = async (endpoint, params) => {
  try {
    const response = await API.post(endpoint, params, {
      headers: { 'content-type': 'multipart/form-data' },
    })
    return response.data
  } catch (error) {
    swalAlert.error(error.response.data.message)
    return null
  }
}

const GET = async (endpoint) => {
  try {
    const response = await API.get(endpoint)
    return response.data
  } catch (error) {
    swalAlert.error(error.response.data.message)
    return null
  }
}

const GET_FILE = async (endpoint) => {
  try {
    const response = await API.get(endpoint, { responseType: 'blob' })
    return response.data
  } catch (error) {
    swalAlert.error(error.response.data.message)
    return null
  }
}

const PATCH = async (endpoint, body, showSuccesAlert = true) => {
  try {
    const response = await API.patch(endpoint, body)
    if (showSuccesAlert)
      await swalAlert.succesWithTimer(
        'El registro se ha actualizado correctamente',
      )
    return response.data
  } catch (error) {
    swalAlert.error(error.response.data.message)
    return null
  }
}

const DELETE = async (endpoint) => {
  try {
    const response = await API.delete(endpoint)
    await swalAlert.succesWithTimer('El registro se ha eliminado correctamente')
    return response.data
  } catch (error) {
    swalAlert.error(error.response.data.message)
    return null
  }
}

export { POST, POST_FILE, GET, GET_FILE, PATCH, DELETE }
